import React, { useCallback, useState } from 'react'
import { Formik, Form as FormikForm } from 'formik'
import * as yup from 'yup'
import { FormContext } from '@/Components/formik-steps/contexts'
import axios from 'axios'
import Loader from '@/Components/Loader'

const FormProvider = ({
    initialValues = {},
    initialValidationSchema = yup.object(),
    beforeCaching = function (values) {
        return values
    },
    useCachedValuesCallback = async function (values) {
        return values
    },
    env = {
        endpoint: ''
    },
    submitOnEnterClick = false,
    beforeSubmitting = function (values) {
        return values
    },
    onSuccess = function (values) { },
    onError = function (errors) { },
    children
}) => {
    const [validationSchema, setValidationSchema] = useState(initialValidationSchema)

    const updateValidationSchema = (validation) => setValidationSchema(yup.object({ ...validation }))

    const [loading, setLoading] = useState(false)

    const onSubmit = useCallback((values, { setErrors, setSubmitting }) => {
        values = beforeSubmitting(values)

        setSubmitting(true)
        setLoading(true)

        axios.post(env.endpoint, values, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                localStorage.removeItem('formik_values')

                // redirect to thankyou page
                window.location.href = '/bedankt'
                
                onSuccess(values, data ?? {})
            })
            .catch((error) => {
                if (error.response) {
                    const { status, data } = error.response

                    const { errors } = data

                    if (422 === status) {
                        setErrors({ ...errors })
                    }

                    onError(errors)
                }
            })
            .finally(() => {
                setLoading(false)
                setSubmitting(false)
            })
        // eslint-disable-next-line
    }, [env.endpoint])

    /**
     * Stop enter submitting the form.
     * @param keyEvent Event triggered when the user presses a key.
     */
    function onKeyDown(keyEvent) {
        if (submitOnEnterClick) {
            return
        }

        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            keyEvent.preventDefault();
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={onSubmit}>
            {(formik) => {
                return (
                    <FormContext.Provider value={{
                        setFieldValue: formik.setFieldValue,
                        validateForm: formik.validateForm,
                        updateValidationSchema,
                        setFieldError: formik.setFieldError,
                        setFieldTouched: formik.setFieldTouched,
                        values: formik.values,
                        validationSchema,
                        setErrors: formik.setErrors,
                        isSubmitting: formik.isSubmitting,
                        errors: formik.errors,
                        submitForm: formik.submitForm
                    }}>
                        {loading && <Loader />}
                        <FormikForm className='form' onKeyDown={onKeyDown}>
                            {children}
                        </FormikForm>
                    </FormContext.Provider>
                )
            }}
        </Formik>

    )

}

export default FormProvider
